import { render, staticRenderFns } from "./deliveryDelegates.vue?vue&type=template&id=68547832&"
import script from "./deliveryDelegates.vue?vue&type=script&lang=js&"
export * from "./deliveryDelegates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports